import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import $ from 'jquery';
import { Worm } from 'reactApp/ui/Worm/Worm';

const render = () => {
    const $container = $(`#react-top-worm`);

    if (!$container.length) {
        return;
    }

    const component = new BReactComponent({
        ReactComponent: Worm,
        renderMode: 'append',
    });

    component.renderTo($container, {});
};

const topWormBanner = () => {
    app.on('page:start', () => {
        render();
    });
};

export default topWormBanner;
